import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class Admin_Dashboard_UpComming_Increment implements IAdmin_Dashboard_UpComming_Increment {
    employee!: EmployeeSummaryDto;
    employeeName!: string | undefined;
    effectiveDate!: Date | undefined;
    eventDay!: string | undefined;
    basicSalary!: number;

    constructor(data?: IAdmin_Dashboard_UpComming_Increment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.employeeName = _data["employeeName"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.eventDay = _data["eventDay"];
            this.basicSalary = _data["basicSalary"];
        }
    }

    static fromJS(data: any): Admin_Dashboard_UpComming_Increment {
        data = typeof data === 'object' ? data : {};
        let result = new Admin_Dashboard_UpComming_Increment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["employeeName"] = this.employeeName;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["eventDay"] = this.eventDay;
        data["basicSalary"] = this.basicSalary;
        return data; 
    }
}

export interface IAdmin_Dashboard_UpComming_Increment {
    employee: EmployeeSummaryDto;
    employeeName: string | undefined;
    effectiveDate: Date | undefined;
    eventDay: string | undefined;
    basicSalary: number;
}

